import type { Precision } from '@/modules/calendar/model/calendar/data-series-entry';

export class FormattingUtil {
  private constructor() {}

  static formatNumber(
    input: string | null | number | undefined,
    precision?: Precision,
  ): string | null | number | undefined {
    if (input === null || input === undefined) return input;

    const floatValue = parseFloat(`${input}`);

    if (isNaN(floatValue)) return input;

    if (!precision) {
      return (floatValue + Math.sign(floatValue) * Number.EPSILON).toLocaleString('en-US', {
        maximumFractionDigits: 3,
        minimumFractionDigits: 1,
      });
    }

    if (precision.precisionType === 'DECIMAL_PLACES') {
      return (floatValue + Math.sign(floatValue) * Number.EPSILON).toLocaleString('en-US', {
        maximumFractionDigits: precision.precisionValue,
        minimumFractionDigits: precision.precisionValue,
      });
    }

    const [integerPart = '', decimalPart = ''] = `${Math.abs(floatValue)}`.split('.');

    if (integerPart.length > precision.precisionValue) {
      return (floatValue + Number.EPSILON).toLocaleString('en-US', {
        maximumSignificantDigits: precision.precisionValue,
      });
    }

    if (integerPart !== '0') {
      return (floatValue + Number.EPSILON).toLocaleString('en-US', {
        maximumFractionDigits: Math.max(0, precision.precisionValue - integerPart.length),
        minimumFractionDigits: Math.max(0, precision.precisionValue - integerPart.length),
      });
    }

    const firstNonZeroIndex = decimalPart.split('').findIndex(char => char !== '0');

    return (floatValue + Number.EPSILON).toLocaleString('en-US', {
      maximumFractionDigits: firstNonZeroIndex + precision.precisionValue,
      minimumFractionDigits: firstNonZeroIndex + precision.precisionValue,
    });
  }
}
